import { useEffect } from "react";

// The store's editable content (Merch → Storefront in the admin), read from
// the public config. A missing or half-filled value always means "automatic",
// so an older API, or an empty CMS, renders exactly the default store.

export const DEFAULT_CONTENT = {
  displayFont: "caps",
  hero: { mode: "auto", collectionSlug: null, productSlug: null, eyebrow: "", title: "", text: "", ctaLabel: "", ctaHref: "", imageUrl: null, font: "inherit", align: "left", overlay: 55, height: "tall", showCountdown: true },
  announcement: { mode: "auto", text: "", href: "" },
  trust: { show: true, items: [] },
  sections: { collections: true },
};

// Ballet is not a shop face. Anything unknown (an old "script" choice) is capitals.
const FACES = ["caps", "blackletter"];

export function contentOf(config) {
  const c = config?.content || {};
  const hero = { ...DEFAULT_CONTENT.hero, ...(c.hero || {}) };
  return {
    displayFont: FACES.includes(c.displayFont) ? c.displayFont : "caps",
    hero: { ...hero, font: FACES.includes(hero.font) ? hero.font : "inherit" },
    announcement: { ...DEFAULT_CONTENT.announcement, ...(c.announcement || {}) },
    trust: { ...DEFAULT_CONTENT.trust, ...(c.trust || {}), items: Array.isArray(c.trust?.items) ? c.trust.items : [] },
    sections: { ...DEFAULT_CONTENT.sections, ...(c.sections || {}) },
  };
}

// Capitals (Archivo Narrow) come with the site; the
// blackletter face is fetched only when a page asks for it.
const PIRATA = "https://fonts.googleapis.com/css2?family=Pirata+One&display=swap";
export function useFaces(...faces) {
  const need = faces.includes("blackletter");
  useEffect(() => {
    if (!need || document.getElementById("shop-font-pirata")) return;
    const link = document.createElement("link");
    link.id = "shop-font-pirata";
    link.rel = "stylesheet";
    link.href = PIRATA;
    document.head.appendChild(link);
  }, [need]);
}

// Internal paths route inside the app; https links open in a new tab.
export const isExternal = (href) => /^https?:\/\//i.test(href || "");
